var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.hideButton ? _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.text)) + " ")]) : _vm._e(), _vm.isDialogActive ? _c('confirm-action-dialog', {
    attrs: {
      "width": "1050",
      "persistent": true,
      "supressKeyboardActions": true,
      "title": _vm.dialogStep.title,
      "subtitle": _vm.dialogStep.subtitle,
      "isDialogActive": _vm.isDialogActive,
      "leftText": _vm.dialogStep.leftText,
      "rightText": _vm.dialogStep.rightText,
      "loading": _vm.isLoading,
      "rightLoading": _vm.isLoading,
      "rightDisabled": _vm.dialogStep.rightDisabled,
      "fullscreen": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "close": _vm.close,
      "leftClick": _vm.dialogStep.leftClick,
      "rightClick": _vm.dialogStep.rightClick,
      "hover:action": _vm.validate
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return undefined;
      },
      proxy: true
    }], null, false, 1648903300)
  }, [_c('m-detail-view-grid', {
    attrs: {
      "center": true
    },
    scopedSlots: _vm._u([{
      key: "details",
      fn: function fn() {
        return [_c('select-entity', {
          attrs: {
            "refType": _vm.ResourceEnum.FLEET,
            "partnerId": _vm.invoice.partnerId,
            "label": _vm.$t('objects.invoice.fleetId'),
            "clearable": true,
            "required": false
          },
          model: {
            value: _vm.invoice.fleetId,
            callback: function callback($$v) {
              _vm.$set(_vm.invoice, "fleetId", $$v);
            },
            expression: "invoice.fleetId"
          }
        }), _c('select-entity', {
          attrs: {
            "refType": _vm.ResourceEnum.VEHICLE,
            "partnerId": _vm.invoice.partnerId,
            "label": _vm.$t('objects.invoice.vehicleId'),
            "clearable": true,
            "required": false
          },
          model: {
            value: _vm.invoice.vehicleId,
            callback: function callback($$v) {
              _vm.$set(_vm.invoice, "vehicleId", $$v);
            },
            expression: "invoice.vehicleId"
          }
        }), _c('select-entity', {
          attrs: {
            "refType": _vm.ResourceEnum.REPORT,
            "partnerId": _vm.invoice.partnerId,
            "label": _vm.$t('objects.invoice.reportId'),
            "clearable": true,
            "required": false
          },
          model: {
            value: _vm.invoice.reportId,
            callback: function callback($$v) {
              _vm.$set(_vm.invoice, "reportId", $$v);
            },
            expression: "invoice.reportId"
          }
        }), _vm.tableRow && _vm.tableRow.length > 0 ? _c('v-simple-table', {
          staticClass: "mt-n6 pb-6"
        }, [_c('tbody', _vm._l(_vm.tableRow, function (row) {
          return _c('tr', {
            key: row.key.toString()
          }, [_c('td', [_vm._v(_vm._s(row.key))]), _c('td', [_vm._v(_vm._s(row.note))]), _c('td', [_c('v-btn', {
            attrs: {
              "icon": "",
              "color": "primary"
            },
            on: {
              "click": function click($event) {
                return _vm.addNote("".concat(row.key, " : ").concat(row.note));
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-clipboard-arrow-right-outline")])], 1)], 1)]);
        }), 0)]) : _vm._e(), _c('group-type-selection-detail-component', {
          attrs: {
            "isUpdate": false
          },
          model: {
            value: _vm.invoice,
            callback: function callback($$v) {
              _vm.invoice = $$v;
            },
            expression: "invoice"
          }
        })];
      },
      proxy: true
    }], null, false, 3163459575)
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "outlined": "",
      "color": "rgb(245, 245, 245);",
      "max-width": "800"
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.isFormValid,
      callback: function callback($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('invoice-form-preview', {
    ref: "invoiceForm",
    attrs: {
      "value": _vm.invoice,
      "readonly": _vm.invoice.status !== _vm.InvoiceStatusEnum.DRAFT,
      "coverageType": _vm.coverageType
    }
  })], 1)], 1)], 1), _c('debug', [_vm._v(" " + _vm._s(_vm.invoice) + " ")])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }